var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSbpImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 822.32 681.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}.cls-23{fill:url(#linear-gradient-23);}.cls-24{fill:url(#linear-gradient-24);}.cls-25{fill:url(#linear-gradient-25);}.cls-26{fill:url(#linear-gradient-26);}.cls-27{fill:url(#linear-gradient-27);}.cls-28{fill:url(#linear-gradient-28);}.cls-29{fill:url(#linear-gradient-29);}.cls-30{fill:url(#linear-gradient-30);}.cls-31{fill:url(#linear-gradient-31);}.cls-32{fill:url(#linear-gradient-32);}.cls-33{fill:url(#linear-gradient-33);}.cls-34{fill:url(#linear-gradient-34);}.cls-35{fill:url(#linear-gradient-35);}.cls-36{fill:url(#linear-gradient-36);}.cls-37{fill:url(#linear-gradient-37);}.cls-38{fill:url(#linear-gradient-38);}.cls-39{fill:url(#linear-gradient-39);}.cls-40{fill:url(#linear-gradient-40);}.cls-41{fill:url(#linear-gradient-41);}.cls-42{fill:url(#linear-gradient-42);}.cls-43{fill:url(#linear-gradient-43);}.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-50,.cls-51,.cls-55,.cls-56{fill:none;stroke-miterlimit:10;}.cls-44{stroke:url(#linear-gradient-44);}.cls-45{stroke:url(#linear-gradient-45);}.cls-46{stroke:url(#linear-gradient-46);}.cls-47{stroke:url(#linear-gradient-47);}.cls-48{stroke:url(#White_Black);}.cls-49{stroke:url(#linear-gradient-48);}.cls-50{stroke:url(#linear-gradient-49);}.cls-51{stroke:url(#linear-gradient-50);}.cls-52{fill:#dde1e6;opacity:0.5;}.cls-53{fill:#0f62fe;}.cls-54{fill:url(#linear-gradient-51);}.cls-55{stroke:url(#linear-gradient-52);}.cls-56{stroke:url(#linear-gradient-53);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1312.7,
    y1: 682.37,
    x2: 1334.55,
    y2: 723.48,
    gradientTransform: "matrix(0.71, -0.71, -0.71, -0.71, 167.81, 1690.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878d96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f4f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -116.91,
    y1: -206.4,
    x2: -67.22,
    y2: -235.08,
    gradientTransform: "translate(454.19 404.72) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#697077"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f4f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -100.91,
    y1: -206.4,
    x2: -51.22,
    y2: -235.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -36.94,
    y1: -206.22,
    x2: 12.84,
    y2: -234.96,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1312.7,
    y1: 714.37,
    x2: 1334.55,
    y2: 755.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1312.7,
    y1: 730.37,
    x2: 1334.55,
    y2: 771.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1312.7,
    y1: 746.37,
    x2: 1334.55,
    y2: 787.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1312.7,
    y1: 794.37,
    x2: 1334.55,
    y2: 835.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1312.7,
    y1: 810.37,
    x2: 1334.55,
    y2: 851.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1312.7,
    y1: 826.37,
    x2: 1334.55,
    y2: 867.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1483.18,
    y1: 207.27,
    x2: 1505.03,
    y2: 248.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 359.19,
    y1: -376.88,
    x2: 408.87,
    y2: -405.56,
    gradientTransform: "translate(251.1 765.33) rotate(-45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 375.19,
    y1: -376.88,
    x2: 424.87,
    y2: -405.56,
    gradientTransform: "translate(251.1 765.33) rotate(-45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 439.16,
    y1: -376.7,
    x2: 488.94,
    y2: -405.45,
    gradientTransform: "translate(251.1 765.33) rotate(-45)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1483.18,
    y1: 238.27,
    x2: 1505.03,
    y2: 279.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1483.18,
    y1: 254.27,
    x2: 1505.03,
    y2: 295.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1483.18,
    y1: 270.27,
    x2: 1505.03,
    y2: 311.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1483.18,
    y1: 318.27,
    x2: 1505.03,
    y2: 359.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1483.18,
    y1: 334.27,
    x2: 1505.03,
    y2: 375.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1483.18,
    y1: 350.27,
    x2: 1505.03,
    y2: 391.39,
    gradientTransform: "matrix(-0.71, -0.71, -0.71, 0.71, 1536.54, 1051.71)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 894.08,
    y1: 709.79,
    x2: 915.93,
    y2: 750.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -144.32,
    y1: 212.22,
    x2: -94.64,
    y2: 183.54,
    gradientTransform: "translate(55.05 573.33) rotate(-135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -128.32,
    y1: 212.22,
    x2: -78.64,
    y2: 183.54,
    gradientTransform: "translate(55.05 573.33) rotate(-135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -64.36,
    y1: 212.39,
    x2: -14.58,
    y2: 183.65,
    gradientTransform: "translate(55.05 573.33) rotate(-135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 894.08,
    y1: 741.79,
    x2: 915.93,
    y2: 782.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 894.08,
    y1: 757.79,
    x2: 915.93,
    y2: 798.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 894.08,
    y1: 773.79,
    x2: 915.93,
    y2: 814.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 894.08,
    y1: 821.79,
    x2: 915.93,
    y2: 862.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 894.08,
    y1: 837.79,
    x2: 915.93,
    y2: 878.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 894.08,
    y1: 853.79,
    x2: 915.93,
    y2: 894.9,
    gradientTransform: "matrix(-0.71, 0.71, 0.71, 0.71, 341.43, -712.1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 667.56,
    y1: 564.9,
    x2: 744.12,
    y2: 564.9,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c7cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 145.1,
    y1: 472.54,
    x2: 186.18,
    y2: 496.25,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dde1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 80.98,
    y1: 140.28,
    x2: 157.55,
    y2: 140.28,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 952.59,
    y1: 202.89,
    x2: 974.44,
    y2: 244,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 363.58,
    y1: 153.7,
    x2: 413.26,
    y2: 125.02,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 379.58,
    y1: 153.7,
    x2: 429.26,
    y2: 125.02,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 443.54,
    y1: 153.88,
    x2: 493.32,
    y2: 125.13,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 952.59,
    y1: 233.89,
    x2: 974.44,
    y2: 275,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 952.59,
    y1: 249.89,
    x2: 974.44,
    y2: 291,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 952.59,
    y1: 265.89,
    x2: 974.44,
    y2: 307,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 952.59,
    y1: 313.89,
    x2: 974.44,
    y2: 355,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 952.59,
    y1: 329.89,
    x2: 974.44,
    y2: 371,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 952.59,
    y1: 345.89,
    x2: 974.44,
    y2: 387,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -333.27, 20.38)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 509.9,
    y1: 105.08,
    x2: 607.22,
    y2: 105.08,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f62fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33b1ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 509.9,
    y1: 113.56,
    x2: 633.26,
    y2: 113.56,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 461.9,
    y1: 33.85,
    x2: 604.68,
    y2: 33.85,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    xlinkHref: "#linear-gradient-33"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 105.92,
    y1: 414.98,
    x2: 200.4,
    y2: 414.98,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33b1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "White_Black",
    x1: 77.05,
    y1: 407.91,
    x2: 200.4,
    y2: 407.91,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 103.51,
    y1: 488.69,
    x2: 248.4,
    y2: 488.69,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 80.9,
    y1: 72.24,
    x2: 265.4,
    y2: 72.24,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#878d96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 141.4,
    y1: 124.74,
    x2: 198.9,
    y2: 124.74,
    gradientTransform: "translate(346 -85.13) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#878d96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#dde1e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 216.01,
    y1: 584.8,
    x2: 323.82,
    y2: 584.8,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f62fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde1e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 507.08,
    y1: 118.48,
    x2: 659.94,
    y2: 118.48,
    gradientTransform: "translate(952.17 306.76) rotate(135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f62fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1c7cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 634.94,
    y1: 226.91,
    x2: 653.44,
    y2: 226.91,
    xlinkHref: "#linear-gradient-52"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OPACITY") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sencenje"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M640,224.86a4,4,0,0,0-6.41,4.59L573.08,290l1.41,1.42,60.4-60.4a4,4,0,0,0,5.11-6.11Zm-1.41,1.41a2,2,0,0,1-2.24,3.24,2,2,0,0,1-.59-.41,2,2,0,1,1,2.83-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M583.16,144.87a4,4,0,0,0-6.27,4.85l-71.51,71.51,1.42,1.42,71.51-71.51a4,4,0,0,0,4.85-6.27Zm-3.34,4.75a2,2,0,1,1,1.93-.51A2,2,0,0,1,579.82,149.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M594.48,156.18a4,4,0,0,0-6.27,4.86L516.7,232.55l1.41,1.41,71.51-71.51a4,4,0,0,0,4.86-6.27Zm-3.35,4.76a2,2,0,0,1-.89-.52,1.87,1.87,0,0,1-.52-.9,2,2,0,0,1,.52-1.93,2,2,0,0,1,2.82,2.83A2,2,0,0,1,591.13,160.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M639.73,201.43a4,4,0,0,0-6.26,4.89L561.77,278l1.41,1.41,71.72-71.72a4,4,0,0,0,4.83-6.29Zm-3.31,4.77a1.93,1.93,0,0,1-.93-.52,2,2,0,0,1-.51-.87,2,2,0,0,1,.51-2,2,2,0,1,1,.93,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M617.37,202.23a4,4,0,0,0-6.41,4.59l-60.51,60.51,1.42,1.41,60.4-60.4a4,4,0,0,0,5.1-6.11ZM616,203.64a2,2,0,0,1-2.24,3.24,2.09,2.09,0,0,1-.59-.41,1.91,1.91,0,0,1-.57-1.25,2,2,0,0,1,.57-1.58A2,2,0,0,1,616,203.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M606.06,190.92a4,4,0,0,0-6.42,4.59L539.14,256l1.41,1.42L601,197a4,4,0,0,0,5.11-6.11Zm-1.42,1.41a2,2,0,0,1-2.23,3.24,2,2,0,0,1-.59-.41,2,2,0,0,1-.58-1.25,2,2,0,0,1,.58-1.58A2,2,0,0,1,604.64,192.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M594.74,179.6a4,4,0,0,0-6.41,4.59L527.82,244.7l1.42,1.41,60.4-60.4a4,4,0,0,0,5.1-6.11ZM593.33,181a2,2,0,0,1-2.23,3.24,2.21,2.21,0,0,1-.6-.41,2,2,0,0,1-.57-1.26,2,2,0,0,1,.57-1.57A2,2,0,0,1,593.33,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M560.8,145.66a4,4,0,0,0-6.41,4.59l-60.51,60.51,1.42,1.41,60.4-60.4a4,4,0,0,0,5.1-6.11Zm-1.41,1.42a2,2,0,0,1-2.24,3.23,2,2,0,0,1-1.16-1.66,2,2,0,0,1,.57-1.57A2,2,0,0,1,559.39,147.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M549.49,134.35a4,4,0,0,0-6.41,4.59l-60.51,60.5,1.41,1.42,60.4-60.4a4,4,0,0,0,5.11-6.11Zm-1.41,1.41a2,2,0,0,1-2.24,3.24,2,2,0,0,1-.59-.41,2,2,0,0,1-.58-1.25,2,2,0,0,1,.58-1.58A2,2,0,0,1,548.08,135.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M538.18,123a4,4,0,0,0-6.42,4.59l-60.5,60.51,1.41,1.41,60.4-60.4a4,4,0,0,0,5.11-6.11Zm-1.42,1.42a2,2,0,0,1-2.23,3.24,2.37,2.37,0,0,1-.6-.41,2,2,0,0,1-.57-1.25,2,2,0,0,1,3.4-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M286.64,123a4,4,0,0,0,4.59,6.42L351.74,190l1.41-1.42-60.4-60.4a4,4,0,0,0-6.11-5.11Zm1.41,1.42a2,2,0,1,1,0,2.83A2,2,0,0,1,288.05,124.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M207.35,179.16a4,4,0,0,0,4.86,6.27l71.51,71.51,1.42-1.41L213.63,184a4,4,0,0,0-6.28-4.86Zm4.76,3.35a1.94,1.94,0,0,1-1.41,1.41,2,2,0,1,1,1.41-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M218.67,167.85a4,4,0,0,0,4.86,6.27L295,245.63l1.41-1.41-71.51-71.51a4,4,0,0,0-6.27-4.86Zm4.76,3.34a2,2,0,0,1-1.42,1.42,2,2,0,0,1-1.93-.52,2,2,0,0,1,2.83-2.83A2,2,0,0,1,223.43,171.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M263.92,122.59a4,4,0,0,0,4.89,6.26l71.71,71.71,1.41-1.41-71.72-71.73a4,4,0,0,0-6.29-4.83Zm4.77,3.31a2,2,0,0,1-.52.94,2.2,2.2,0,0,1-.87.51,2,2,0,1,1,1.39-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M264.72,145a4,4,0,0,0,4.59,6.42l60.5,60.51,1.42-1.42-60.4-60.4a4,4,0,0,0-6.11-5.11Zm1.41,1.42A2,2,0,0,1,269,149.2a2,2,0,0,1-1.25.57,2,2,0,0,1-1.58-.57A2,2,0,0,1,266.13,146.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M253.4,156.27a4,4,0,0,0,4.59,6.41l60.51,60.51,1.42-1.42-60.41-60.4a4,4,0,0,0-6.11-5.1Zm1.42,1.41a2,2,0,0,1,2.83,0,2,2,0,0,1,.41,2.24,2.32,2.32,0,0,1-.41.59,1.93,1.93,0,0,1-1.25.57,2,2,0,0,1-1.58-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M242.09,167.58a4,4,0,0,0,4.59,6.42l60.51,60.5,1.41-1.41-60.4-60.4a4,4,0,0,0-6.11-5.11Zm1.42,1.42a2,2,0,0,1,3.23,2.23,2,2,0,0,1-3.23.59A2,2,0,0,1,243.51,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M208.15,201.52a4,4,0,0,0,4.59,6.42l60.51,60.5,1.41-1.41-60.4-60.4a4,4,0,0,0-6.11-5.11Zm1.41,1.42a2,2,0,0,1,3.24,2.23,2.14,2.14,0,0,1-.41.6,2,2,0,1,1-2.83-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M196.84,212.84a4,4,0,0,0,4.59,6.41l60.5,60.51,1.42-1.42L203,217.94a4,4,0,0,0-6.11-5.1Zm1.41,1.41a2,2,0,0,1,2.83,0,2,2,0,0,1,.41,2.24,2.09,2.09,0,0,1-.41.59,1.93,1.93,0,0,1-1.25.57,2,2,0,0,1-1.58-3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M185.52,224.15a4,4,0,0,0,4.59,6.41l60.51,60.51,1.41-1.41-60.4-60.4a4,4,0,0,0-6.11-5.11Zm1.42,1.41a2,2,0,0,1,3.24,2.24,2.16,2.16,0,0,1-.41.59,2,2,0,0,1-1.26.58,2,2,0,0,1-1.57-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M184.64,476.57a4,4,0,0,0,6.41-4.59l60.51-60.51-1.41-1.41-60.4,60.4a4,4,0,0,0-5.11,6.11Zm1.41-1.41a2,2,0,0,1,2.24-3.24,2,2,0,0,1,1.17,1.66,2,2,0,0,1-3.41,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M241.48,556.56a4,4,0,0,0,6.27-4.86l71.51-71.5-1.42-1.42-71.51,71.51a4,4,0,0,0-4.85,6.27Zm3.34-4.76a2.17,2.17,0,0,1,.9.52,1.94,1.94,0,0,1,.51.9,2,2,0,1,1-3.34-.9A2,2,0,0,1,244.82,551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M230.16,545.25a4,4,0,0,0,6.27-4.86l71.51-71.51-1.41-1.41L235,539a4,4,0,0,0-4.86,6.27Zm3.35-4.76a2,2,0,0,1,1.41,1.41,2,2,0,0,1-.52,1.93,2,2,0,1,1-2.82-2.82A2,2,0,0,1,233.51,540.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M184.91,500a4,4,0,0,0,6.25-4.88l71.71-71.71L261.46,422l-71.72,71.72a4,4,0,0,0-4.83,6.28Zm3.31-4.76a1.93,1.93,0,0,1,.93.52,2,2,0,0,1,.51.86,2,2,0,0,1-.51,2,2,2,0,1,1-.93-3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M207.27,499.2a4,4,0,0,0,6.41-4.59l60.51-60.51-1.42-1.41-60.4,60.4a4,4,0,0,0-5.1,6.11Zm1.41-1.42a2,2,0,0,1,2.24-3.23,2,2,0,0,1,1.16,1.66,2,2,0,0,1-.57,1.57A2,2,0,0,1,208.68,497.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M218.58,510.51a4,4,0,0,0,6.41-4.59l60.51-60.5L284.09,444l-60.4,60.4a4,4,0,0,0-5.11,6.11ZM220,509.1a2,2,0,0,1,2.23-3.24,2,2,0,0,1,.59.41A2,2,0,0,1,220,509.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M229.89,521.83a4,4,0,0,0,6.42-4.59l60.51-60.51-1.42-1.41L235,515.72a4,4,0,0,0-5.11,6.11Zm1.42-1.42a2,2,0,0,1,2.23-3.24,2.21,2.21,0,0,1,.6.41,2,2,0,0,1,.57,1.25,2,2,0,0,1-3.4,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M263.84,555.77a4,4,0,0,0,6.41-4.59l60.51-60.51-1.42-1.41-60.4,60.4a4,4,0,0,0-5.1,6.11Zm1.41-1.42a2,2,0,0,1,2.23-3.24,2.21,2.21,0,0,1,.6.41,2,2,0,0,1,.57,1.26,2,2,0,0,1-.57,1.57A2,2,0,0,1,265.25,554.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M275.15,567.08a4,4,0,0,0,6.41-4.59L342.07,502l-1.41-1.41L280.25,561a4,4,0,0,0-5.1,6.11Zm1.41-1.41a2,2,0,0,1,2.24-3.24,2,2,0,0,1,.59.41,1.91,1.91,0,0,1,.57,1.25,2,2,0,0,1-.57,1.58A2,2,0,0,1,276.56,565.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M286.46,578.39a4,4,0,0,0,6.42-4.59l60.5-60.5L352,511.88l-60.4,60.4a4,4,0,0,0-5.11,6.11Zm1.42-1.41a2,2,0,0,1,2.23-3.24,2.14,2.14,0,0,1,.6.41,2,2,0,0,1,.57,1.25,2,2,0,0,1-3.4,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M96.91,406.94a4.4,4.4,0,0,0,1.28,2.63,4.48,4.48,0,1,0-1.3-3.63H0v1Zm1-1a3.39,3.39,0,0,1,1-2,3.56,3.56,0,0,1,4.94,0,3.49,3.49,0,1,1-4.94,4.94,3.39,3.39,0,0,1-1-1.92,2.56,2.56,0,0,1,0-.55A3.4,3.4,0,0,1,97.9,405.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M520,114.34a4.5,4.5,0,1,0,0-9,4.56,4.56,0,0,0-2.84,1L460.32,49.47l-.71.71,56.9,56.89a4.49,4.49,0,0,0,3.53,7.27Zm-3.5-4.49a3.53,3.53,0,0,1,.67-2.07,3.62,3.62,0,0,1,.7-.71,3.43,3.43,0,0,1,2.14-.72,3.48,3.48,0,0,1,3.49,3.49,3.5,3.5,0,0,1-3.5,3.51,3.52,3.52,0,0,1-3.5-3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M717.63,295a4.49,4.49,0,0,0,6.36,0,4.44,4.44,0,0,0,1.28-2.59h97.05v-1h-97a4.5,4.5,0,1,0-7.66,3.59Zm.7-5.66a3.52,3.52,0,0,1,5,0,3.42,3.42,0,0,1,1,2.07,3.35,3.35,0,0,1,0,1,3.5,3.5,0,1,1-5.93-3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M538.35,577a4,4,0,0,0-4.59-6.41l-60.5-60.51-1.42,1.41,60.4,60.4a4,4,0,0,0,6.11,5.11Zm-1.41-1.41a2,2,0,0,1-3.24-2.24,2,2,0,0,1,.41-.59,2,2,0,0,1,1.25-.58,2,2,0,0,1,1.58.58A2,2,0,0,1,536.94,575.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M617.64,520.85a4,4,0,0,0-4.86-6.27l-71.51-71.51-1.42,1.41L611.36,516a4,4,0,0,0,6.28,4.86Zm-4.76-3.34a1.94,1.94,0,0,1,.51-.9,2.06,2.06,0,0,1,.9-.52,2,2,0,1,1-.9,3.35A2,2,0,0,1,612.88,517.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M606.32,532.17a4,4,0,0,0-4.85-6.28L530,454.38l-1.42,1.42,71.51,71.51a4,4,0,0,0,6.27,4.86Zm-4.76-3.35a2.17,2.17,0,0,1,.52-.9,1.94,1.94,0,0,1,.9-.51,2,2,0,1,1-.9,3.34A2,2,0,0,1,601.56,528.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M561.07,577.42a4,4,0,0,0-4.89-6.26l-71.71-71.71-1.41,1.42,71.72,71.72a4,4,0,0,0,6.29,4.83Zm-4.77-3.31a2,2,0,0,1,1.39-1.44,2,2,0,1,1-.86,3.34A2,2,0,0,1,556.3,574.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M560.27,555.06a4,4,0,0,0-4.59-6.41l-60.5-60.51-1.42,1.41,60.4,60.4a4,4,0,0,0,6.11,5.11Zm-1.41-1.41a2,2,0,0,1-3.24-2.24,2,2,0,0,1,.41-.59,2,2,0,0,1,2.83,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M571.59,543.75a4,4,0,0,0-4.59-6.42l-60.51-60.5-1.41,1.41,60.4,60.4a4,4,0,0,0,6.11,5.11Zm-1.42-1.42a2,2,0,0,1-3.24-2.23,2.37,2.37,0,0,1,.41-.6,2.06,2.06,0,0,1,1.25-.57,2,2,0,0,1,1.58,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M582.9,532.43a4,4,0,0,0-4.59-6.41L517.8,465.51l-1.41,1.42,60.4,60.4a4,4,0,0,0,6.11,5.1ZM581.49,531a2,2,0,0,1-3.24-2.24,2.09,2.09,0,0,1,.41-.59,1.91,1.91,0,0,1,1.25-.57,2,2,0,0,1,1.58.57A2,2,0,0,1,581.49,531Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M616.84,498.49a4,4,0,0,0-4.59-6.41l-60.51-60.51L550.33,433l60.4,60.41a4,4,0,0,0,6.11,5.1Zm-1.41-1.41a2,2,0,0,1-3.24-2.24,2.09,2.09,0,0,1,.41-.59,1.91,1.91,0,0,1,1.25-.57,2,2,0,0,1,1.58.57A2,2,0,0,1,615.43,497.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M628.15,487.18a4,4,0,0,0-4.58-6.42l-60.51-60.5-1.42,1.41,60.41,60.4a4,4,0,0,0,6.1,5.11Zm-1.41-1.42a2,2,0,0,1-3.24-2.23,2.37,2.37,0,0,1,.41-.6,2,2,0,0,1,1.25-.57,2,2,0,0,1,1.58,3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M639.47,475.86a4,4,0,0,0-4.59-6.41l-60.51-60.51L573,410.36l60.4,60.4a4,4,0,0,0,6.11,5.1Zm-1.42-1.41a2,2,0,0,1-3.23-2.24,2,2,0,0,1,1.66-1.16,2,2,0,0,1,1.57.57A2,2,0,0,1,638.05,474.45Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-44",
    points: "598.38 383.61 649.99 435.22 700.9 384.31 734.79 384.31"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-45",
    points: "586.35 395.63 649.99 459.27 706.56 402.7 753.23 402.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-46",
    points: "598.38 316.43 649.99 264.81 700.9 315.72 799.79 315.72"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "227.14 317.14 175.53 265.52 124.61 316.43 94.73 316.43"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-48",
    points: "239.16 305.12 175.53 241.48 118.96 298.05 72.29 298.05"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-49",
    points: "227.14 384.31 175.53 435.93 124.61 385.02 22.73 385.02"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-50",
    points: "459.07 176.42 505.04 130.46 374.93 0.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-51",
    points: "367.86 174.3 327.55 134 389.07 72.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M690,350.64,412.13,72.74,134.24,350.64,412.13,628.53ZM412.13,454.43,308.34,350.64l103.79-103.8,103.8,103.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 338.74,
    y: 277.24,
    width: 146.79,
    height: 146.79,
    transform: "translate(-127.23 394.12) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M469.53,525.17,644.06,350.64,412.13,118.7,180.2,350.64,354.73,525.17V478.79L226.59,350.64,412.13,165.1,597.68,350.64,469.53,478.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M412.13,223.08,284.57,350.64,395.73,461.8V566.17l16.4,16.4,16.4-16.4V461.8L539.69,350.64Zm0,208.73L331,350.64l81.18-81.18,81.18,81.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M312.86,123.54a4.5,4.5,0,0,0,4.5-4.5,4.45,4.45,0,0,0-1.32-3.18l0,0L385.89,46l-.71-.71-69.95,69.95a4.5,4.5,0,1,0-2.37,8.33Zm-3.5-4.49a3.51,3.51,0,0,1,5.14-3.11,3.41,3.41,0,0,1,.81.6l0,0a3.51,3.51,0,0,1-2.49,6,3.52,3.52,0,0,1-3.49-3.49Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-55",
    points: "393.48 681.37 484.7 590.15 517.93 590.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-56",
    points: "319.94 573.18 364.49 617.73 351.76 630.45"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbpImg);
export default __webpack_public_path__ + "static/media/sbp-img.1f59ee9fc8965a1b70e33a7ff59d943e.svg";
export { ForwardRef as ReactComponent };